// src/app/shared/data/year.data.ts

export const MF_YEAR_LIST = (() => {
  const currentYear = new Date().getFullYear();
  const startYear = 1975;
  const years = [];

  for (let year = currentYear; year >= startYear; year--) {
    years.push({ value: year.toString(), label: year.toString() });
  }

  return years;
})();


export const REG_YEAR_LIST = (() => {
  const currentYear = new Date().getFullYear();
  const startYear = 1975;
  const years = [];

  for (let year = currentYear; year >= startYear; year--) {
    years.push({ value: year.toString(), label: year.toString() });
  }

  return years;
})();
